import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardMedia } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';

import { IProducto } from '../Interfaces/IProductos';
import { getProductos } from '../Services/Productos';
import Loading from '../Utils/Loading';
import DialogProductDescription from '../Components/Dialog/DialogProductDescription';

import atrasIcon from '../Shared/Images/atras-icon.png';

import styles from './Styles/MyProducts.module.css';


const MyProducts = () => {
  const [productos, setProductos] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [producto, SetProduct] = useState<IProducto>();
  const [isCompras, setIsCompras] = useState(false);
  const matches = useMediaQuery('(max-width: 655px)');

  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem('user')) {
      let value = localStorage.getItem('user');
      let user = typeof value === 'string' ? JSON.parse(value) : '';
      getProductos({
        UsuarioTestAsesoriaID: user.usuarioTestAsesoriaID,
      }).then((result: any) => {
        setProductos(result.data.data.productosEnVenta);
      });
    }
  }, []);

  return (
    <div style={{ margin: '1rem 0' }}>
      <div
        className="flex align-items-center"
        style={{ gap: '1rem', paddingLeft: '1rem', marginBottom: '1.5rem' }}
        onClick={() => navigate('/')}
      >
        <img src={atrasIcon} style={{ width: '35px', height: '25px' }} />
        <p
          style={{ margin: '0', fontWeight: 'bold', fontSize: '1.5rem' }}
          className="title"
        >
          Mis Productos
        </p>
      </div>
      <div
        style={{
          color: 'black',
          display: 'grid',
          gap: '1rem',
        }}
        className={styles.grid}
      >
        {productos && productos.length > 0 ? (
          productos.map((product: any, i: number) => (
            <>
              {matches && i !== 0 && (
                <div style={{ border: '1px solid #BFBFBF', width: '100%' }}></div>
              )}
              <Card
                className="px-2"
                style={{ boxShadow: 'none' }}
                key={i}
                sx={{ width: '95%' }}
              >
                <div onDragStart={(e) => e.preventDefault()}>
                  <CardMedia
                    component="img"
                    src={product.portada}
                    onClick={() => {
                      if (product.subTipo === 'Programa' || product.subTipo === 'Mini Curso') {
                        navigate(`/producto/${product.tipoPagoID}`);
                      } else {
                        setDialogOpen(true);
                        if (isCompras) {
                          setIsCompras(true);
                        }
                        SetProduct(product);
                      }
                    }}
                    alt="Paella dish"
                    sx={{
                      boxShadow: '0px 15px 15px -5px grey',
                      height: '200px',
                      borderRadius: '15px',
                      cursor: 'pointer',
                      '&:hover': {
                        transition: '.4s ease',
                        opacity: '0.7',
                      },
                    }}
                  />
                  <div
                    className="flex align-items-center"
                    style={{ margin: '.5rem 0' }}
                  >
                    <div
                      className={`${styles.title} title`}
                      style={{ fontWeight: 'bold', fontSize: '16px', color: 'grey' }}
                    >
                      {product.subTipo}:
                    </div>
                    <div
                      className={`m-2 ${styles.title} title`}
                      style={{ fontWeight: 'bold', fontSize: '20px' }}
                    >
                      {product.titulo}
                    </div>
                  </div>
                </div>
              </Card>
            </>
          ))
        ) : (
          <div
            style={{
              height: '80vh',
              width: '100vw',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              position: 'absolute',
              top: '60px',
            }}
          >
            <Loading />
          </div>
        )}
        {dialogOpen && (
          <DialogProductDescription
            isOpen={dialogOpen}
            isCompras={isCompras}
            setIsOpen={setDialogOpen}
            setIsCompras={setIsCompras}
            producto={producto!}
          />
        )}
      </div>
    </div>
  );
};

export default MyProducts;
